import React, { useState } from "react";
import Button from "components/common/Button";
import IntegrationAPI from "lib/api/Integration";

export default function ProcoreCard({ companyUuid, integration, onChanged }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const status = integration?.status || "disconnected";

  const connect = async () => {
    setBusy(true);
    setError("");
    const res = await IntegrationAPI.connectProcore(companyUuid);
    if (res.status === 200 && res.data?.authorize_url) {
      window.location.assign(res.data.authorize_url);
      return;
    }
    setError(res.message || "Could not start the Procore connection.");
    setBusy(false);
  };

  const disconnect = async () => {
    if (!window.confirm("Disconnect Procore from this company?")) return;
    setBusy(true);
    const res = await IntegrationAPI.disconnectProcore(companyUuid);
    setBusy(false);
    if (res.status === 200) onChanged();
    else setError(res.message || "Could not disconnect Procore.");
  };

  // No company-list route exists, so (re)choosing a company re-runs OAuth and
  // the callback page shows the picker.
  const changeCompany = connect;

  return (
    <div
      style={{
        border: "1px solid #d4d9e1",
        borderRadius: 6,
        padding: 16,
        marginBottom: 16,
        background: "#fff",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Procore</h3>

      {error && <p style={{ color: "#b00020" }}>{error}</p>}

      {status === "disconnected" && (
        <Button className="primary" disabled={busy} onClick={connect}>
          Connect Procore
        </Button>
      )}

      {status === "pending_company" && (
        <>
          <p>Choose a Procore company to finish connecting.</p>
          <Button className="primary" disabled={busy} onClick={changeCompany}>
            Choose company
          </Button>
          <Button disabled={busy} onClick={disconnect}>
            Disconnect
          </Button>
        </>
      )}

      {status === "connected" && (
        <>
          <p>
            Connected to <strong>{integration.external_company_name}</strong>
            {integration.external_user_email && (
              <>
                {" "}
                as <strong>{integration.external_user_email}</strong>
              </>
            )}
          </p>
          <Button disabled={busy} onClick={changeCompany}>
            Change company
          </Button>
          <Button disabled={busy} onClick={connect}>
            Reconnect
          </Button>
          <Button disabled={busy} onClick={disconnect}>
            Disconnect
          </Button>
        </>
      )}

      {status === "needs_reauth" && (
        <>
          <p style={{ color: "#b00020" }}>
            The Procore connection expired and needs to be re-authorized.
          </p>
          <Button className="primary" disabled={busy} onClick={connect}>
            Reconnect
          </Button>
          <Button disabled={busy} onClick={disconnect}>
            Disconnect
          </Button>
        </>
      )}
    </div>
  );
}
